import React, { Component } from 'react';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction" // needed for dayClick

class Calendar extends Component {

  render() {
    return (
        <FullCalendar
            buttonText={{today: 'Today'}}
            height={"480px"}
            plugins={[ dayGridPlugin, interactionPlugin ]}
            initialView="dayGridMonth"
            eventClick={this.handleDateClick}
            eventContent={renderEventContent}
            events={this.props.event}
        />
    );
  }

  handleDateClick = (arg) => { // bind with an arrow function
    this.props.handleClick(arg.event._def.extendedProps.data)
  }
}

function renderEventContent(eventInfo) {
    return (
      <>
        <b>{eventInfo.timeText}</b>
        <small className="pl-2">{eventInfo.event.title}</small>
      </>
    )
  }

export default Calendar;